export const MAIN_ROUTE = '/'

const lektorsEnv = JSON.parse(process.env.REACT_APP_LEKTORS || '')
export const Lektors = lektorsEnv
